import { Outlet } from 'react-router'

export default function ConfigurationsLayout() {
  return <Outlet />
}
